import { render } from "./LoginForm.vue?vue&type=template&id=5cd32d84&scoped=true"
import script from "./LoginForm.vue?vue&type=script&lang=js"
export * from "./LoginForm.vue?vue&type=script&lang=js"

import "./LoginForm.vue?vue&type=style&index=0&id=5cd32d84&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5cd32d84"

export default script